import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../../utils/updateObject';

const initialState = {
    details : {}
};

export default function (state = initialState, action) {
    //console.log(action);
    switch (action.type) {
        case actionTypes.FETCH_OFFICE_SUCCESS: 
        //return updateObject(state, action.val);
        // console.log("OFFICE_FETCHED");
        return {...state,details : action.val};
        default:
          break;
    }
    return state;
}